import { apiService } from '../../../shared/services/apiService';
import { LoadedFile } from '../../../shared/interfaces/LoadedFile';
import { GetRegistrationLinkResponse, RegistrationService } from './registrationService';

export const nutritionRegistrationService: RegistrationService = {
  async getRegistrationLink(entityId: number) {
    const resp = await apiService.get<GetRegistrationLinkResponse>(
      `api/entity/${entityId}/settings/customer-setup/link`,
    );

    return resp.data;
  },

  async getRegistrationQrCode(entityId: number) {
    const resp = await apiService.get<LoadedFile>(
      `api/entity/${entityId}/settings/customer-setup/qr-code`,
    );

    return resp.data;
  },
};
